// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xKhi","placeholdersHeader":"styles_placeholdersHeader__tndAw","editorStyle":"styles_editorStyle__3g3px","placeholdersBox":"styles_placeholdersBox__3uFB3"};